/**
 * @internal
 * Checks whether the fragment only contains a single image to paste
 * and the editor have the ConvertSingleImageBody Experimental feature
 * @param props Properties related to the PasteEvent
 * @returns
 */
var shouldConvertToSingleImage = function (props) {
    var _a;
    var shouldConvertSingleImage = props.shouldConvertSingleImage, clipboardData = props.clipboardData;
    return (shouldConvertSingleImage &&
        ((_a = clipboardData.htmlFirstLevelChildTags) === null || _a === void 0 ? void 0 : _a.length) == 1 &&
        clipboardData.htmlFirstLevelChildTags[0] == 'IMG');
};
export default shouldConvertToSingleImage;
//# sourceMappingURL=shouldConvertToSingleImage.js.map